import React from "react";
import { Alert, AlertTitle } from "@mui/material";

/**
 * Aviso NO bloqueante de completitud del perfil para operar registros DNDA.
 * Espejo cliente de assertTenantProfileCompleteForDnda (server): mismos campos
 * para persona física y jurídica; solo cambia la etiqueta de legalName. No
 * impide guardar (el onboarding es progresivo) — el gate duro corre al generar
 * documentación.
 *
 * Los datos del Gestor TAD no se revisan acá: dejaron de ser del perfil de cada
 * editorial y viven en la Configuración del Gestor TAD, única para todo Jupiter.
 */
export const TenantProfileDndaCompletenessNotice: React.FC<{
  personType: string;
  legalName: string;
  businessId: string;
}> = ({ personType, legalName, businessId }) => {
  const isLegalEntity = personType === "legalEntity";
  const missing: string[] = [];
  if (!legalName?.trim()) {
    missing.push(isLegalEntity ? "Nombre del representado" : "Razón social");
  }
  if (!businessId?.trim()) missing.push("CUIT");

  if (missing.length === 0) return null;

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <AlertTitle>Datos pendientes para registros DNDA</AlertTitle>
      Para poder generar documentación y registrar ediciones en la DNDA faltan:{" "}
      <strong>{missing.join(", ")}</strong>. Se puede guardar igual y completar
      más adelante: la generación de documentación los va a exigir.
    </Alert>
  );
};
